import { gql } from '@apollo/client';

export const DIVIDEND_DISTRIBUTION_FRAGMENT = gql`
  fragment DividendDistributionFragment on DividendDistribution {
    id
    orderStatus
    orderType
    isQualified
    isReinvested
    payDate
    amount
    createTime
    sourceAsset: asset {
      symbol
    }
    distributionAsset {
      symbol
    }
  }
`;

export const DIVIDEND_DISTRIBUTION_EDGE = gql`
  fragment DividendDistributionEdge on DividendDistributionEdge {
    node {
      ...DividendDistributionFragment
    }
  }
  ${DIVIDEND_DISTRIBUTION_FRAGMENT}
`;

export const CAPITAL_GAINS_DISTRIBUTION_FRAGMENT = gql`
  fragment CapitalGainsDistributionFragment on CapitalGainsDistribution {
    id
    orderStatus
    orderType
    isReinvested
    capitalGainPayDate: payDate
    amount
    createTime
    sourceAsset {
      symbol
    }
    distributionAsset {
      symbol
    }
  }
`;

export const CAPITAL_GAINS_DISTRIBUTION_EDGE = gql`
  fragment CapitalGainsDistributionEdge on CapitalGainsDistributionEdge {
    node {
      ...CapitalGainsDistributionFragment
    }
  }
  ${CAPITAL_GAINS_DISTRIBUTION_FRAGMENT}
`;

export const RETURN_OF_CAPITAL_DISTRIBUTION_FRAGMENT = gql`
  fragment ReturnOfCapitalDistributionFragment on ReturnOfCapitalDistribution {
    id
    orderStatus
    orderType
    isReinvested
    returnOfCapitalPayDate: payDate
    amount
    createTime
    sourceAsset {
      symbol
    }
    distributionAsset {
      symbol
    }
  }
`;

export const RETURN_OF_CAPITAL_DISTRIBUTION_EDGE = gql`
  fragment ReturnOfCapitalDistributionEdge on ReturnOfCapitalDistributionEdge {
    node {
      ...ReturnOfCapitalDistributionFragment
    }
  }
  ${RETURN_OF_CAPITAL_DISTRIBUTION_FRAGMENT}
`;
